import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { inject, Injectable, signal } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { Utilities } from '../../shared/utils/utilities';

@Injectable()
export class RouteTrackingService {
  previousUrl: string = '';
  currentUrl: string = '';
  normalizedCurrentUrl: string = '';
  clearWizardDataRun = signal<boolean>(false);

  constructor(router: Router, locationStrategy: LocationStrategy) {
    router.events
      .pipe(filter((event): event is NavigationStart => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => {
        this.previousUrl = this.normalizedCurrentUrl;
        this.currentUrl = event.url;
        this.normalizedCurrentUrl = this.normalizeUrl(event.url);
      });

    router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (this.clearWizardDataRun()) {
          this.clearWizardDataRun.set(false);
          Utilities.disableBrowsersBackButton(locationStrategy);
        }
      });
  }
  public normalizeUrl(url: string): string {
    const patterns = [
      { regex: /\/vertrag\/(\d+)/g, replacement: '/vertrag/{{contractId}}' },
    ];

    let normalizedUrl = url;
    patterns.forEach(pattern => {
      normalizedUrl = normalizedUrl.replace(pattern.regex, pattern.replacement);
    });

    return normalizedUrl;
  }
}

export const routeTrackingProvider = {
  provide: RouteTrackingService,
  useFactory: () => {
    const router = inject(Router);
    const locationStrategy = inject(LocationStrategy);
    return new RouteTrackingService(router, locationStrategy);
  }
};
